import {Component} from 'react';
import reformatDateToDisplay from '../../../objects/CommonUse/reformatDateToDisplay_function';
import { doubleToStringMonthly } from '../../../objects/CommonUse/double_functions';

class SavingsCDList extends Component {
    constructor(props) {
        super(props);
        this.state = {
         selectedRows: {},
         rerender: false,
        };
        this.text = this.props.tableInfo.autoRollover;
        this.setAutoRolloverChangeValue();
    }

    setAutoRolloverChangeValue(){
        this.newAutoRollover = this.props.tableInfo.autoRollover;
        if (this.props.tableInfo.autoRollover === true){
            this.autoRollover = "Yes";
        }else{
            this.autoRollover = "No";
        }
        if (this.props.tableInfo.highlightRow === true){
            this.rowClass = "table-primary"
        }
    }

    handleCheckboxChange = () => {
        if (this.newAutoRollover === true){
            this.newAutoRollover = false;
        }else{
            this.newAutoRollover = true;
        }
        let changeSw = false;
        if (this.newAutoRollover !== this.props.tableInfo.autoRollover){
            changeSw = true;
        }
        const CDReturnObj = {date: this.props.tableInfo.date, autoRollover: this.newAutoRollover,
            changeSw: changeSw
        };
        this.props.updateCDList(CDReturnObj);
        if (changeSw === true){
            this.setState({rerender: !this.state.rerender});
            this.props.processCDList();
        }
    };
    
    render() {
        if (this.props.tableInfo.autoRollover === this.props.tableInfo.newAutoRollover){
            this.checkBox = false;
        }else{
            this.checkBox = true;
        }
        if (this.newAutoRollover === true){
            this.text = "Yes";
        }else{
            this.text = "No";
        }
    return <>
        <tr className={this.rowClass}>
            <td className="text-center p-2">{reformatDateToDisplay(this.props.tableInfo.startDate)}</td>
            <td className="text-center p-2">{doubleToStringMonthly(this.props.tableInfo.amount)}</td>
            <td className="text-center p-2">{doubleToStringMonthly(this.props.tableInfo.intAmt)}</td>
            <td className="text-center p-2">{this.autoRollover}</td>
            <td className="text-center p-2">
                <input
                  type="checkbox"
                  checked={this.checkBox}
                  onChange={() => this.handleCheckboxChange()}
                />
                <span style={{ marginLeft: '5px' }}>{this.text}</span>
              </td>
            <td className="text-left p-0 font-weight-bold">{this.props.tableInfo.updtStatus}</td>
        </tr>

    </>
    }
}

export default SavingsCDList;